import { create } from 'zustand'
import { getSystemConfig } from '@/service/api/setting'
import { SystemConfig } from '@/types/setting'

interface ConfigState {
  config: SystemConfig | null
  
  // Actions
  fetchConfig: () => Promise<void>
}

export const useConfigStore = create<ConfigState>((set) => ({
  config: null,

  fetchConfig: async () => {
    try {
      const config = await getSystemConfig()
      set({ config })
      
      // Update document title and favicon dynamically
      if (typeof window !== 'undefined') {
        if (config.site_name) {
          document.title = config.site_name
        }
        
        if (config.site_favicon) {
          let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
          if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
          }
          link.href = config.site_favicon;
        }
      }
    } catch (error) {
      console.error('Failed to fetch system config:', error)
    }
  }
}))
